
import React, { Component, Fragment } from 'react';
import Loading from '../../Loading';
import meetingAPI from '../../../flowtrace-api/meetingAPI';

import AuditTable from './auditTable';
import FilterBar from '../../Common/FilterBar';

const tooManyResults = {text:"Maximum meeting count reached.", tooltip:"Please refine your search for complete results."};

class MeetingStatisticsTable extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, searchWarning:null, queryFilters: { range_type: "calendar", range_period:"day", range_limit: 28} };
  }


  async loadProductivityStatistics(queryFilters) {
    const data = await meetingAPI.audit(queryFilters, this.props.flowtraceUser);
    const meetings = data.meetings || [];
    const searchWarning = data.warning ? {text: "Maximum meeting count reached.", tooltip: data.warning} : (meetings.length >= 5000 ? tooManyResults : null);
    const searchError = data.error ? {text: "Meeting audit experienced an error.", tooltip: data.error} : null;

    return this.setState({ loading: false, ...data, meetings, searchWarning, searchError });
  }

  onChange(queryFilters) {
    this.setState({ loading: true, queryFilters });
    this.loadProductivityStatistics(queryFilters);
  }

  async componentDidMount() {
    this.loadProductivityStatistics(this.state.queryFilters);
  }

  componentWillUnmount() { this.setState = () => { return; }; }

  render() {
    if(this.state.loading)
    return (
      <Fragment>
        <FilterBar teamFilter meetingFilter hidePeriod searchWarning={this.state.searchWarning} searchError={this.state.searchError} loading={this.state.loading} flowtraceUser={ this.props.flowtraceUser } queryFilters={{...this.state.queryFilters }} onChange={this.onChange.bind(this)} />
        <Loading text={"This feature requires Google or Outlook integration. Please inquire your account manager for more details."}/>
      </Fragment>);

    return (
      <Fragment>
        <FilterBar teamFilter meetingFilter hidePeriod searchWarning={this.state.searchWarning} searchError={this.state.searchError} loading={this.state.loading} flowtraceUser={ this.props.flowtraceUser } queryFilters={{...this.state.queryFilters }} onChange={this.onChange.bind(this)} />

        <AuditTable flowtraceUser={this.props.flowtraceUser} queryFilters={this.state.queryFilters} members={this.state.members} meetings={this.state.meetings} loading={this.state.loading} />

        </Fragment>
    );
  } // end of render()
} // end of class

  // props.flowtraceUser
  // props.queryFilters
  // props.members
  // props.loading
  // props.meetings
  // props.title

export default MeetingStatisticsTable
